"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchMultiSelectWrapper = exports.StyledSearchText = exports.StyledMultiSelectSearch = exports.StyledMultiSelectSelectedList = exports.StyledSelectSelectedItemLabel = exports.StyledSelectSelectedItem = exports.StyledSelectSelectedList = exports.StyledSelectIconSmall = exports.StyledSelectIconCross = exports.StyledSelectIcon = exports.StyledSelectSearch = exports.StyledSelectText = exports.StyledSelect = exports.StyledSelectWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const models_1 = require("../../../../../shared/models");
const styles_1 = require("../../../../../styles");
const focusHover_1 = require("../../../../../styles/focusHover");
const tokens_1 = require("../../../../../styles/tokens");
const { blue } = tokens_1.COLOURS.primary;
const { white, dishwater, stone, zinc, metal } = tokens_1.COLOURS.greyscale;
const searchFocusBoxShadowStyling = `0 0 0 2px ${tokens_1.COLOURS.greyscale.white},
    0 0 0 4px ${tokens_1.COLOURS.primary.blue[100]}`;
const getBaseStyles = ({ expanded, error, disabled, isSearch, }) => {
    if (disabled) {
        return (0, styles_1.inputStateStyles)({ state: models_1.InputStates.DISABLED });
    }
    if (error) {
        return (0, styles_1.inputStateStyles)({ state: models_1.InputStates.ERROR });
    }
    if (isSearch) {
        return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.DEFAULT })), { border: (0, styles_1.setBorderColour)("transparent") });
    }
    if (expanded) {
        if (isSearch) {
            return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.DEFAULT })), { border: "none" });
        }
        return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.FOCUS })), { borderWidth: "1px" });
    }
    return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.DEFAULT })), { border: (0, styles_1.setBorderColour)(metal) });
};
const getHoverStyles = ({ disabled, expanded, error, isSearch, }) => {
    if (disabled) {
        return (0, styles_1.inputStateStyles)({ state: models_1.InputStates.DISABLED });
    }
    if (error) {
        return (0, styles_1.inputStateStyles)({ state: models_1.InputStates.ERROR });
    }
    if (isSearch) {
        return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.DEFAULT })), { border: (0, styles_1.setBorderColour)("transparent") });
    }
    if (expanded) {
        return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.FOCUS })), { backgroundColor: white });
    }
    return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({
        state: models_1.InputStates.HOVER,
    })), { boxShadow: focusHover_1.hoverBoxShadow, backgroundColor: white });
};
const getFocusStyles = ({ disabled, error, expanded, isSearch, }) => {
    if (disabled) {
        return (0, styles_1.inputStateStyles)({ state: models_1.InputStates.DISABLED });
    }
    if (error) {
        return (0, styles_1.inputStateStyles)({ state: models_1.InputStates.ERROR });
    }
    if (isSearch) {
        return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.FOCUS })), { boxShadow: searchFocusBoxShadowStyling });
    }
    if (expanded) {
        return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.FOCUS })), { border: (0, styles_1.setBorderColour)(metal), boxShadow: "none" });
    }
    return Object.assign(Object.assign({}, (0, styles_1.inputStateStyles)({ state: models_1.InputStates.FOCUS })), { boxShadow: focusHover_1.focusBoxShadow });
};
exports.StyledSelectWrapper = styled_components_1.default.div `
    height: ${(props) => props.height ? `${props.height}px` : `${tokens_1.SIZES[4]}px`};
    position: relative;
    margin-bottom: ${(props) => props.marginBottom ? `${props.marginBottom}` : `${tokens_1.SIZES[1.5]}px`};
    z-index: ${(props) => props.zIndex};
`;
exports.StyledSelect = styled_components_1.default.div `
    ${tokens_1.TYPOGRAPHY.body.base};
    width: 100%;
    border-radius: ${tokens_1.BORDERS.radius};
    margin-bottom: ${tokens_1.SIZES[1.5]};
    outline: none;
    ${focusHover_1.defaultTransitionStyles}

    cursor: ${({ expanded, theme }) => expanded && theme !== "DEFAULT" ? "default" : "pointer"};

    ${({ expanded, error, disabled }) => getBaseStyles({ expanded, error, disabled })};

    &:hover,
    &:active,
    &:focus,
    &:focus-visible {
        ${({ disabled, error, expanded }) => getHoverStyles({ disabled, error, expanded })}
    }

    &:focus&:focus,
    &:focus-visible {
        ${({ disabled, error, expanded }) => getFocusStyles({ disabled, error, expanded })};
    }

    &:hover,
    &:active,
    &:focus,
    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusHoverInsetBorderStyles}
    }
`;
exports.StyledSelectText = styled_components_1.default.div `
    padding: ${(props) => props.dimension === "large" ? tokens_1.SIZES[1.5] : tokens_1.SIZES[1]};
`;
// N.B. ms-clear and ms-reveal are needed for IE support
exports.StyledSelectSearch = styled_components_1.default.input `
    padding: ${(props) => props.dimension === "large" ? tokens_1.SIZES[1.5] : tokens_1.SIZES[1]};
    width: 100%;
    font-size: 1rem;
    font-style: italic;
    border-radius: ${tokens_1.BORDERS.radius};
    outline: none;

    ${({ expanded, error, disabled }) => getBaseStyles({ expanded, error, disabled, isSearch: true })};

    &:focus&:focus,
    &:focus-visible {
        ${({ disabled, error }) => getFocusStyles({ disabled, error, isSearch: true })};
    }

    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
        display: none;
        -webkit-appearance: none;
    }

    &::-ms-clear,
    &::-ms-reveal {
        display: none;
        width: 0;
        height: 0;
    }

    &:hover,
    &:active,
    &:focus,
    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusHoverInsetBorderStyles}
    }
`;
exports.StyledSelectIcon = styled_components_1.default.span `
    position: absolute;
    right: ${tokens_1.SIZES[1.5]};
    top: ${(props) => (props.dimension !== "large" ? tokens_1.SIZES[1] : tokens_1.SIZES[1.5])};
    z-index: 2;
    display: block;
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
`;
exports.StyledSelectIconCross = (0, styled_components_1.default)(exports.StyledSelectIcon) `
    right: ${tokens_1.SIZES[5]};
    top: ${(props) => (props.dimension === "large" ? tokens_1.SIZES[1.5] : tokens_1.SIZES[1])};
`;
exports.StyledSelectIconSmall = styled_components_1.default.span `
    display: inline-block;
    padding: 0 ${tokens_1.SIZES[0.5]} ${tokens_1.SIZES[0.25]} ${tokens_1.SIZES[0.5]};
    margin-left: ${tokens_1.SIZES[0.5]};
    cursor: pointer;

    &:hover {
        background-color: ${blue[100]};
    }
`;
exports.StyledSelectSelectedList = styled_components_1.default.ul `
    padding: ${tokens_1.SIZES[1]} ${tokens_1.SIZES[1.5]};
    margin: 0;
    width: 85%;
`;
exports.StyledSelectSelectedItem = styled_components_1.default.li `
    ${tokens_1.TYPOGRAPHY.note.base};
    font-size: ${tokens_1.TYPOGRAPHY.note.desktop.fontSize};
    display: inline-block;
    position: relative;
    padding: 0 0 0 ${tokens_1.SIZES[1]};
    background-color: ${blue[10]};
    border: ${(0, styles_1.setBorderColour)(blue[100])};
    border-radius: ${tokens_1.BORDERS.radius};
    margin: ${tokens_1.SIZES[0.5]} ${tokens_1.SIZES[1]} ${tokens_1.SIZES[0.5]} 0;

    svg {
        position: relative;
        top: ${tokens_1.SIZES[0.5]};
        vertical-align: initial;
    }

    &[aria-disabled="true"] {
        background-color: ${dishwater};
        border-color: ${stone};
        color: ${zinc};
        span {
            cursor: default;

            &:hover {
                background-color: ${dishwater};
            }
        }
    }
`;
exports.StyledSelectSelectedItemLabel = styled_components_1.default.div `
    display: inline-block;
    padding-top: 1px; /* offset 1px for aligning text to center */
`;
exports.StyledMultiSelectSelectedList = styled_components_1.default.ul `
    padding: ${tokens_1.SIZES[0.5]} ${tokens_1.SIZES[1]};
    margin: 0;
    width: 85%;
`;
exports.StyledMultiSelectSearch = styled_components_1.default.input `
    ${tokens_1.TYPOGRAPHY.preview.base};
    width: 100%;
    outline: none;
    font-size: 1rem;
    ${({ expanded, error, disabled }) => getBaseStyles({ expanded, error, disabled, isSearch: true })};
    border: none;
    &:focus&:focus,
    &:focus-visible {
        ${({ disabled, error }) => getFocusStyles({ disabled, error, isSearch: true })};
        border: none;
        box-shadow: none;
    }
    /* added to remove buttons on search input text */
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
        display: none;
        -webkit-appearance: none;
    }
`;
exports.StyledSearchText = styled_components_1.default.li `
    ${tokens_1.TYPOGRAPHY.note.base};
    display: inline-block;
    position: relative;
    padding: 0;
    margin: ${tokens_1.SIZES[0.5]};
`;
exports.StyledSearchMultiSelectWrapper = styled_components_1.default.div `
    min-height: 40px;
`;
//# sourceMappingURL=SelectInput.styles.js.map